
import { Component, Vue, Prop } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';

@Component({
  mixins: [Themeable],
})
export default class WildcardDialog extends Vue {
  @Prop() public domain!: string;

  @Prop() public remove!: boolean;

  public visible: boolean = true;

  public createWildcard(): void {
    this.$emit('createWildcard', this.remove);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');
    this.visible = false;
  }
}
